module.exports = __webpack_public_path__ + "static/media/success.23e0cf00.png";